// extracted by mini-css-extract-plugin
export default {"Month":"SGJd0","title-wrap":"Ka2FS","title":"o01pI","year":"lCsgf","skeleton-progress":"dHZoK"};